import React from "react";
import useLanguageChange from "../../hooks/useLanguageChange";
import { useSelector } from "react-redux";
import clsx from "clsx";
import extractTextService from "../../services/extractTextService";
import { CopyTextOrLinkToClipboard } from "../../shared/utility";
import { EXTRACT_TEXT_VIEW } from "../../constants/Constants";

const ExtractTextCopyModal = () => {
    const localisedValues = useLanguageChange();
    const { openCopyTextModal, fetchedOCRText, ocrCopyText, extractTextInprogress } = useSelector((state) => state.extractText);

    const closeModal = () => {
        extractTextService.removeCopyModel();
    };

    const copyExtractText = () => {
        CopyTextOrLinkToClipboard(ocrCopyText, localisedValues.text_copied);
    };

    return (
        <div
            className={clsx("information-modal", openCopyTextModal && extractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW && "active")}
            id='copy-extract-text-modal'
            data-testid='extractText-copyModel'
        >
            <div className='information-modal-box'>
                <div className='information-modal-head'>
                    <div className='title'>{localisedValues?.extract_text_result}</div>
                    <div className='information-modal-close'>
                        <button className='btn close-btn' onClick={closeModal}>
                            <span className='btn-icon icon-close-light'></span>
                        </button>
                    </div>
                </div>
                {fetchedOCRText && (
                    <div className='copy-extract-text'>
                        <div className='copy-extract-text-head'>
                            <div className='title'>{localisedValues?.text_copied_to_clipboard}</div>
                            <div className='copy-extract-text-button'>
                                <button className='btn copy-btn' onClick={copyExtractText}>
                                    <span className='btn-icon icon-copy-text'></span>
                                </button>
                            </div>
                        </div>
                        <div className='copy-extract-text-body'>
                            <div className='copy-extract-text-body-scroll default-custom-scroll-thin'>
                                <div className='copy-extract-text-result'>{ocrCopyText}</div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Extract text not found */}
                {!fetchedOCRText && (
                    <div className='extract-text-not-found'>
                        <div className='extract-text-not-found-in'>
                            {localisedValues?.not_extract_text_from_image}&nbsp;{localisedValues?.try_again_clear_image_or_reselect_region}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ExtractTextCopyModal;
